import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../models/tracer.model';

@Pipe({
  name: 'getMethodLabel',
})
export class GetMethodLabelPipe implements PipeTransform {
  transform(req: Request): string {
    if (!req) return '';
    const method = req.Method;
    const provider = req.ProviderMethod;
    if (!provider || provider === method || provider === `${method}RQ`) {
      return method;
    }
    return `${method} (${provider})`;
  }
}
